// extracted by mini-css-extract-plugin
export default {"sideBar":"y4VwpssVeFeuGdY2tosC"};